
import List from "./components/List.vue";
import {
  flatTreeData,
  findParentElements,
  getBreadList,
} from "~/utils/index.js";
export default {
  asyncData({ app, route, store }) {
    const db = app.$websiteDataHelper;

    const routeId = route.meta[0].nodeid;

    const pageBannerbg =
      encodeURI(db.getMenuItemBanner("knowledge")) ||
      "/img/knowledge-page-banner.png";
    const categories = store.state.menu.filter(
      item => item.path === "/products",
    )[0].children;

    const hotProducts = db.hotProducts.slice(0, 3);

    const currentPage = route.meta[0].page ?? 1;
    const pageSize = 12;
    const { list = [], count = 0 } = db.getList(
      "knowledge",
      routeId,
      currentPage,
      pageSize,
    );

    const menus = store.state.menu.filter(m => m.type === "knowledge");
    const currentPath = route.path.split("/")[1];
    const currentVO = app.$websiteDataHelper.getCurrentVO(
      menus,
      `/${currentPath}`,
    );

    const flatArray = flatTreeData(menus);
    const breadList = findParentElements(routeId, flatArray);
    return {
      banner: pageBannerbg,
      title: (currentVO?.name_ch || "knowledge")
        .toUpperCase()
        .replace(/-/g, " "),
      menu: categories,
      total: count,
      hotProducts,
      currentPage,
      pageData: list,
      pageSize,
      customList: breadList,
      currentVO,
    };
  },
  head() {
    const { path, meta } = this.$route;
    const { menu, baseJsonLd } = this.$store.state.jsonLd;
    const siteUrl = baseJsonLd.url;
    const breadList = getBreadList(menu, this.currentVO, 1);

    const jsonld = {
      ...baseJsonLd,
      name: meta?.title,
      description: meta?.description,
      keywords: meta?.keywords,
      url: new URL(path, siteUrl).toString(),
    };

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            jsonld,
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: breadList,
            },
          ],
        },
      ],
    };
  },
  components: { List },
};
